/** Default search params required by `/platform` route validation. */
export const DEFAULT_PLATFORM_SEARCH = {
  view: "overview",
  filter: "all",
  billingTab: "quotations",
  settingsTab: "branding",
} as const;
